/**
 * A dialog component to specify the selected sites.
 */

const ID = 'aims_msp_selected-sites-panel_upload-dialog';
const TEMPLATE = `
<div id="${ID}" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Upload</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <textarea rows="6" />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-upload">Upload</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
`;

export default class UploadDialogComponent {

  constructor(selectedSitesModel, referenceSitesHashModel) {

    // Cache references.
    this._selectedSitesModel = selectedSitesModel;
    this._referenceSitesHashModel = referenceSitesHashModel;

    // Insert the template to render the list.
    $('body').append(TEMPLATE);

    // Display the dialog.
    this._$modalEl = $(`#${ID}`);
    this._$modalEl.modal();

    // Clean up after close.
    this._$modalEl.on('hidden.bs.modal', (e) => {
      this._$modalEl.remove();
    });

    // Add an event handler to the Upload button.
    this._$modalEl.find('.btn-upload').click(this._handleUploadClick.bind(this));
  }

  _handleUploadClick(event) {
    // Identify the uploaded ids.
    const _uploadedIds = [];
    this._$modalEl.find('textarea').val()
      .split('\n')
      .map((_id) => {
        return _id.trim();
      })
      .forEach((_id) => {
        _uploadedIds.push(_id);
      });

    // Identify the corresponding sites from the list of reference sites.
    const _uploadedSites = {};
    const _referenceSites = this._referenceSitesHashModel.getData();
    Object.keys(_referenceSites).forEach((_id) => {
      const index = _uploadedIds.indexOf(_id);
      if (index >= 0) {
        // Reference site found in the list of uploaded ids.
        _uploadedSites[_id] = {
          id: _referenceSites[_id].id,
          latitude: _referenceSites[_id].lat,
          longitude: _referenceSites[_id].lon
        };
        _uploadedIds.splice(index, 1);
      }
    });
    this._selectedSitesModel.setData(_uploadedSites);
    this._$modalEl.modal('hide');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/dialogs/upload-dialog.js